module.exports = __webpack_public_path__ + "b97b7f8d95e237d56c6639b407f05c2d.svg";